import { render, staticRenderFns } from "./ModeSwitcher.vue?vue&type=template&id=48bb3170&scoped=true"
import script from "./ModeSwitcher.vue?vue&type=script&lang=js"
export * from "./ModeSwitcher.vue?vue&type=script&lang=js"
import style0 from "./ModeSwitcher.vue?vue&type=style&index=0&id=48bb3170&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48bb3170",
  null
  
)

export default component.exports